import React, { useState } from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";

const sortOptions = [
  { label: "Newest First", value: "newest" },
  { label: "Oldest First", value: "oldest" },
  { label: "Highest Discount", value: "highest_discount" },
  { label: "Lowest Discount", value: "lowest_discount" },
];

const statusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Expired", value: "expired" },
];

const discountOptions = [
  { label: "0-10%", value: "0-10" },
  { label: "11-25%", value: "11-25" },
  { label: "26-50%", value: "26-50" },
  { label: "Above 50%", value: "above-50" },
];

const Categoryheader = ({ onFilterChange, filters }) => {
  const handleFilterChange = (type, event) => {
    const value = event.target.value;
    if (onFilterChange) {
      onFilterChange({ ...filters, [type]: value });
    }
  };

  const selectStyles = {
    height: "40px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E5E7EB",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E5E7EB",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5652B0",
    },
    "& .MuiSelect-select": {
      paddingTop: "8px",
      paddingBottom: "8px",
    },
  };

  const labelStyles = {
    color: "#6B7280",
    fontSize: "0.875rem",
    "&.Mui-focused": {
      color: "#5652B0",
    },
  };

  return (
    <div className="flex items-center gap-4">
      {/* Sort By Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel sx={labelStyles}>Sort By</InputLabel>
        <Select
          value={filters?.sortBy || ""}
          onChange={e => handleFilterChange("sortBy", e)}
          label="Sort By"
          sx={selectStyles}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {sortOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Status Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel sx={labelStyles}>Status</InputLabel>
        <Select
          value={filters?.status || ""}
          onChange={e => handleFilterChange("status", e)}
          label="Status"
          sx={selectStyles}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {statusOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Discount Range Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel sx={labelStyles}>Discount Range</InputLabel>
        <Select
          value={filters?.discount || ""}
          onChange={e => handleFilterChange("discount", e)}
          label="Discount Range"
          sx={selectStyles}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {discountOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default Categoryheader;
